import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { useBreakpoints, breakpointsTailwind } from '@vueuse/core'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'

type Props = {
    width?: number
    position?: 'stick-to-left' | 'stick-to-right'
    asRegularPopoverBreakpoint?: 'sm' | 'md' | 'lg' | 'xl' | '2xl'
}

export default /*#__PURE__*/_defineComponent({
  props: {
    width: { type: Number, required: false, default: 300 },
    position: { type: String, required: false, default: 'stick-to-left' },
    asRegularPopoverBreakpoint: { type: String, required: false, default: 'sm' }
  },
  setup(__props: any) {

const props = __props as { width: number, position: 'stick-to-left' | 'stick-to-right', asRegularPopoverBreakpoint: 'sm' | 'md' | 'lg' | 'xl' | '2xl' }


const breakpoints = useBreakpoints(breakpointsTailwind)
const asRegularPopover = breakpoints.greater(props.asRegularPopoverBreakpoint)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popover), {
    ref: (_value, _refs) => {
      _refs['popoverRef'] = _value
    },
    class: "relative"
  }, {
    default: _withCtx(({ open, close }) => [
      _createVNode(_unref(PopoverButton), null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "refferer")
        ]),
        _: 3
      }),
      (_openBlock(), _createBlock(_Teleport, {
        to: "body",
        disabled: _unref(asRegularPopover)
      }, [
        open
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed top-0 left-0 w-full h-full bg-dark-gray bg-opacity-50 z-50 px-4 flex items-center md:absolute md:top-auto md:left-auto md:w-auto md:h-auto md:bg-transparent md:px-0 md:block",
              style: _normalizeStyle({
                    ...(_unref(asRegularPopover) && {
                        ...(props.position === 'stick-to-left' && { left: 0 }),
                        ...(props.position === 'stick-to-right' && { right: 0 }),
                    }),
                })
            }, [
              _createVNode(_unref(PopoverPanel), {
                id: "popover",
                ref: (_value, _refs) => {
                  _refs['popoverPanelRef'] = _value
                },
                static: "",
                class: "overflow-auto w-full h-full p-4 bg-gray-bg rounded-lg animate-fade-in-up shadow-md border border-gray-stroke",
                style: _normalizeStyle(_unref(asRegularPopover) && { width: `${props.width}px` })
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "content", { close: close })
                ]),
                _: 2
              }, 1032, ["style"])
            ], 4))
          : _createCommentVNode("", true)
      ], 8, ["disabled"]))
    ]),
    _: 3
  }, 512))
}
}

})